import React, { useRef, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import styles from "./map.module.css";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import moment from 'moment';
import { useCallback } from 'react';
import Form from 'react-bootstrap/Form';

export default function Map() {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const currentMarkers = useRef([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [showOutOfService, setShowOutOfService] = useState(false); // default: hidden
  const tankThresholds = useRef(
    JSON.parse(localStorage.getItem("tankThresholds") || "{}")
  );
  
  const zoomToLocation = () => {
    const longitude =  -111.46087; 
    const latitude = 57.24732; 
    const zoomLevel = 11; // 12-15

    if (map.current) {
      map.current.flyTo({
        center: [longitude, latitude],
        zoom: zoomLevel
      });
    }
  };

  //zones coordinates
  const zonesGeoJSON = {
    "type": "FeatureCollection",
    "features": [
      {
        "type": "Feature",
        "properties": {
          "zoneId": "zone1",
          "color": "#216617"  // right
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-111.03526, 57.43681],
              [-111.02305, 57.43676],
              [-111.0179, 57.4314],
              [-111.01687, 57.42396],
              [-111.03515, 57.42383],
              [-111.03526, 57.43681]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "zoneId": "zone2",
          "color": "#0000ff"
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-111.03526, 57.43681],
              [-111.05051, 57.43738],
              [-111.05046, 57.42387],
              [-111.03515, 57.42383],
              [-111.03526, 57.43681]
            ]
           
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "zoneId": "HP_25",
          "color": "#880e4f"
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-111.03396, 57.40778],
              [-111.03921, 57.40684],
              [-111.05007, 57.41375],
              [-111.05046, 57.42378],
              [-111.03515, 57.42383],
              [-111.03396, 57.40778]
            ]
           
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "zoneId": "HP_26",
          "color": "#1cd49c"
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-111.03396, 57.40778],
              [-111.02639, 57.4089],
              [-111.02544, 57.4064],
              [-111.01879, 57.40726],
              [-111.01278, 57.41047],
              [-111.01687, 57.42396],
              [-111.03515, 57.42383],
              [-111.03396, 57.40778]
            ]
           
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "zoneId": "H5_22",
          "color": "#08158a"  // Left-HP_22
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-111.08143, 57.42427],
              [-111.05653, 57.42422],
              [-111.05539, 57.43439],
              [-111.08143, 57.43428],
              [-111.08143, 57.42427]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "zoneId": "H5_26",
          "color": "#807199"  
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-111.08143, 57.42427],
              [-111.05653, 57.42422],
              [-111.05597, 57.41322],
              [-111.08136, 57.41314],
              [-111.08143, 57.42427]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "zoneId": "H5_20",
          "color": "#acd41c"  
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-111.08143, 57.42427],
              [-111.08758, 57.42415],
              [-111.10706, 57.41888],
              [-111.09864, 57.41317],
              [-111.08136, 57.41314],
              [-111.08143, 57.42427]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "zoneId": "H5_19",
          "color": "#b57059"  
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-111.09655, 57.42778],
              [-111.08758, 57.42415],
              [-111.10706, 57.41888],
              [-111.11162, 57.42252],
              [-111.10792, 57.42984],
              [-111.09655, 57.42788]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "zoneId": "zone1",
          "color": "#362e6b"  
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [-111.09655, 57.42778],
              [-111.08758, 57.42415],
              [-111.08143, 57.42427],
              [-111.08143, 57.43428],
              [-111.10286, 57.43423],
              [-111.10792, 57.42984],
              [-111.09655, 57.42788]
            ]
          ]
        }
      }
      // Add more zones as needed
    ]
  };
  
/*
  function getCenter() {
    //Get preferences from storage
    const storedSettings = JSON.parse(localStorage.getItem("mapbox.lastCentre"));
    if (storedSettings) {
      return mapboxgl.LngLat.convert(storedSettings);
    }
    return new mapboxgl.LngLat(-111.05722, 57.42441);
  }

  function getZoom() {
    //Get preferences from storage
    const storedSettings = JSON.parse(localStorage.getItem("mapbox.lastZoom"));
    if (storedSettings) {
      return storedSettings;
    }
    return 12;
  }
*/
  

//get colored SVG
function getDeviceStatusSVG(device, tankThresholds) {
    // 1. Out of Service → always returns the same icon
    if (device.outOfService === true || device.outOfService === "true") {
        return `/mapIcons/service.svg`;
    }

    // 2. Determine icon prefix based on deviceType
    const type = (device.deviceType || "").toLowerCase();
    let prefix = "location"; // default
    let threshold = 15000; // default


    if (type.includes("margo float squawkBox")) {
        prefix = "fs"; // Float SquawkBox
        threshold = tankThresholds["Margo Float SquawkBox"] || threshold;
    } else if (type.includes("margo float cannon")) {
        prefix = "fc"; // Float Cannon
        threshold = tankThresholds["Margo Float Cannon"] || threshold;
    } else if (type.includes("converted float cannon")) {
        prefix = "cf";
        threshold = tankThresholds["Converted Float Cannon"] || threshold;
    } else if (type.includes("converted land cannon")) {
        prefix = "cl";
        threshold = tankThresholds["Converted Land Cannon"] || threshold;
    } else if (type.includes("margo land cannon")) {
        prefix = "mc";
        threshold = tankThresholds["Margo Land Cannon"] || threshold;
    }

    // Check GPS for red critical status
    const lat = parseFloat(device.latitude);
    const lng = parseFloat(device.longitude);
    const isOutOfBounds = lat < -90 || lat > 90 || lng < -180 || lng > 180;
    const noGps = isNaN(lat) || isNaN(lng) || isOutOfBounds || (Math.abs(lat) < 0.0001 && Math.abs(lng) < 0.0001);

    // 3. Red conditions: critical
    if (
        device.batteryV <= 10.5 ||
        device.batteryV >= 15.0 ||
        device.tankCounter >= threshold ||
        moment().diff(moment(device.recordDate), 'hours') > 24 ||
        noGps
    ) {
        return `/mapIcons/${prefix}red.svg`;
    }

    // 4. Yellow conditions: warning
    if (
        (device.batteryV > 10.5 && device.batteryV < 11.0) ||
        (device.batteryV > 14.5 && device.batteryV < 15.0) ||
        device.lifeCounter > 9000000
    ) {
        return `/mapIcons/${prefix}yellow.svg`;
    }

    // 5 Default: green
    return `/mapIcons/${prefix}green.svg`;
}




function toggleOutOfService(device) {
  const headers = {
    'Content-Type': 'application/json',
    'X-API-KEY': '7EAFDEADBEEF'
  };

  fetch('/api/v1/markOutOfService/', {
    method: 'POST',
    headers,
    body: JSON.stringify({
      deviceID: device.deviceID,
      outOfService: !device.outOfService
    })
  })
    .then(res => res.json())
    .then(() => {
      toast.success(`Device ${device.deviceId} status updated`);
      setSelectedDevice(prev => ({
        ...prev,
        outOfService: !prev.outOfService
      }));
      addDevices(); //to refrtesh the pins with each toggle
    })
    .catch(err => {
      toast.error("Failed to update service status");
      console.error(err);
    });
}


const addDevices = useCallback(async () => {
  toast.dismiss(); // Clear previous toasts
  const mytoast = toast("Fetching Devices", { autoClose: 30000 });

  // Remove existing markers
  currentMarkers.current.forEach(marker => marker.remove());
  currentMarkers.current = []; // Clear marker list

  try {
    const headers = { 'X-API-KEY': '7EAFDEADBEEF' };
    const response = await fetch('/api/v1/statusAll/', { headers });
    if (!response.ok) throw new Error('Network response was not ok');

    const data = await response.json();

    if (data.length > 0) {
      const now = moment();
      const filteredData = data.filter(device => {
        const lastHeard = moment(device.recordDate);
        const daysOld = now.diff(lastHeard, 'days');
        const isOOS = device.outOfService === true || device.outOfService === "true";
        if (!showOutOfService && isOOS) return false; // <-- hide OOS by default
        return daysOld <= 30; // Only include recent devices
      });
    
      filteredData.forEach(device => {
        let lat = parseFloat(device.latitude);
        let lng = parseFloat(device.longitude);

        // Fallback to 0, 0 if coordinates are invalid, missing, or out of bounds so MapLibre doesn't crash
        if (isNaN(lat) || isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) {
          lat = 0;
          lng = 0;
          // Update device object so modal and status checks reflect the fallback
          device.latitude = 0;
          device.longitude = 0;
        }

        const devicelatlng = new maplibregl.LngLat(lng, lat);
        const el = document.createElement('div');
        el.className = styles.mapmarker;
    
        const statusSVG = getDeviceStatusSVG(device, tankThresholds.current);
        el.style.backgroundImage = `url(${process.env.PUBLIC_URL + statusSVG})`;
        el.style.height = '80px';
        el.style.width = '80px';
        el.style.backgroundSize = 'contain';
    
        el.deviceData = device;


    
        el.addEventListener('click', deviceClick);
    
        const marker = new maplibregl.Marker({
          element: el,
          anchor: 'bottom' // <-- This fixes the sliding pins
        }).setLngLat(devicelatlng).addTo(map.current);
        currentMarkers.current.push(marker);
      });    
    } else {
      toast.error("No data found");
    }

    toast.dismiss(mytoast);
  } catch (error) {
    toast.error("Error fetching devices");
    console.error(error);
  }
}, [showOutOfService]);


  function getDeviceStatusReason(device, tankThresholds) {
    if (!device) return "Unknown";

    const rawType = device.deviceType || device.device_type || device.type || "";
    const type = rawType.toLowerCase();
    let threshold = 15000;

    if (type.includes("margo float squawkBox")) {
        threshold = tankThresholds["Margo Float SquawkBox"] || threshold;
    } else if (type.includes("margo float cannon")) {
        threshold = tankThresholds["Margo Float Cannon"] || threshold;
    } else if (type.includes("converted float cannon")) {
        threshold = tankThresholds["Converted Float Cannon"] || threshold;
    } else if (type.includes("converted land cannon")) {
        threshold = tankThresholds["Converted Land Cannon"] || threshold;
    } else if (type.includes("margo land cannon")) {
        threshold = tankThresholds["Margo Land Cannon"] || threshold;
    }

    if (device.outOfService === true || device.outOfService === "true") {
      return "Out of Service";
    }

    const lat = parseFloat(device.latitude);
    const lng = parseFloat(device.longitude);
    const isOutOfBounds = lat < -90 || lat > 90 || lng < -180 || lng > 180;
    const noGps = isNaN(lat) || isNaN(lng) || isOutOfBounds || (Math.abs(lat) < 0.0001 && Math.abs(lng) < 0.0001);

    if (moment().diff(moment(device.recordDate), 'hours') > 24) return "Device MIA";
    if (noGps) return "GPS Error";
    if (device.batteryV <= 10.5) return "Low Battery";
    if (device.batteryV >= 15) return "High Battery";
    if (device.tankCounter >= threshold) return "Empty Tank";

    if (device.batteryV > 10.5 && device.batteryV < 11.0) return "Low Battery Warning";
    if (device.batteryV > 14.0 && device.batteryV < 15.0) return "High Battery Warning";
    if (device.lifeCounter > 1000000) return "High Misfire Count";

    return "OK";
  }





  function deviceClick(event) {

    const device = event.currentTarget.deviceData;
    setShowModal(true);
    setSelectedDevice(device);

  /*
    const target = event.currentTarget;
    const deviceId = target.getAttribute('data-device-id');
    const displayName = target.getAttribute('data-display-name');
    const lastHeard = target.getAttribute('data-last-heard');
    const batteryVoltage = target.getAttribute('data-battery-voltage');
    const tankCounter = target.getAttribute('data-tank-counter');
    const lifeCounter = target.getAttribute('data-life-counter');
    const misfires = target.getAttribute('data-misfires');
    const firmwareV = target.getAttribute('data-firmwareV');
    const outOfService = target.getAttribute('data-out-of-service') === 'true';
    const deviceType = target.getAttribute('data-device-type');
    


  
    // Set the state or open a modal with these details
    setShowModal(true);
    setSelectedDevice({ deviceId, displayName, deviceType, lastHeard, batteryVoltage, tankCounter, lifeCounter, misfires, firmwareV, outOfService });

    */
  }


  
  

  
  //async function deviceClick(device) {
    //toast.success("Firing Cannon" + device.name)
    /*
    let response = await ParticleService.fireCannon(device.id);
    if (response.errors) {
      console.error(response);
      toast.error(response.errors[0]);
    }
    */
  //}

  useEffect(() => {
    toast("Click To See Details & Fire", { autoClose: 10000 });
  
    addDevices(); // Load devices once
    document.addEventListener('dataRefresh', addDevices);
  
    return () => {
      document.removeEventListener('dataRefresh', addDevices);
    };
  }, [addDevices]);
  
  

  useEffect(() => {
    if (map.current) return; // initialize map only once
    map.current = new maplibregl.Map({
      container: mapContainer.current,
      attributionControl: false, // <-- This removes the MapTiler watermark
      // Use MapTiler's standard satellite style as the base map
      style: 'https://api.maptiler.com/maps/satellite/style.json?key=TKzL1obALBaRynw2MJnR',
      center: [-111.460871, 57.24732],
      zoom: 12,
      
    });

    //Adding Modem Locations
    fetch('/api/v1/modems/', {
      headers: {
        'X-API-KEY': '7EAFDEADBEEF'
      }
    })
      .then(res => res.json())
      .then(data => {
        const modemIcon = document.createElement('div');
        modemIcon.style.backgroundImage = 'url("/mapIcons/modem.svg")';
        modemIcon.style.width = '200px';
        modemIcon.style.height = '200px';
        modemIcon.style.backgroundSize = 'contain';
        modemIcon.style.backgroundRepeat = 'no-repeat'

        data.forEach(modem => {
          const marker = new maplibregl.Marker({
            element: modemIcon.cloneNode(true),
            anchor: 'bottom' // <-- This fixes the sliding modem pins
          })
            .setLngLat([modem.longitude, modem.latitude])
            .setPopup(new maplibregl.Popup({offset: 25, anchor: 'bottom', closeButton: false}).setText(`${modem.ip} — ${modem.name}`))
            .addTo(map.current);
        });
      })
      .catch(err => {
        console.error('Failed to load modems:', err);
        toast.error('Could not load modem locations');
      });


      
    map.current.on('load', () => {

      
      // 1. Add your custom ECW raster overlay on top of the satellite base map
      map.current.addSource('custom-ecw-raster', {
        'type': 'raster',
        // PASTE YOUR MAPTILER RASTER TILES URL BELOW (Ensure it has ?key=YOUR_KEY)
        'url': 'https://api.maptiler.com/tiles/019e046a-1ca6-7bb6-9c7b-e27cd4a17335/tiles.json?key=TKzL1obALBaRynw2MJnR',
        'tileSize': 256
      });

      map.current.addLayer({
        'id': 'custom-ecw-layer',
        'type': 'raster',
        'source': 'custom-ecw-raster',
        'paint': {}
      });

       // 2. Add GeoJSON source for all zones (This will draw on top of your custom overlay)
      map.current.addSource('zones-source', {
        'type': 'geojson',
        'data': zonesGeoJSON
      });

    // Add a layer for the zones
    map.current.addLayer({
     'id': 'zones-overlay',
     'type': 'fill',
      'source': 'zones-source',
      'layout': {},
      'paint': {
        'fill-color': ['get', 'color'], // Use the color property from each feature
       'fill-opacity': 0.3
      }
    });

      zoomToLocation();  

    });

    const geolocate = new maplibregl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true
      },
      trackUserLocation: true,
      showUserHeading: true
    });
    const nav = new maplibregl.NavigationControl({
      showCompass: true
    });
    
    //Add basic controls
    map.current.addControl(geolocate);
    map.current.addControl(nav, 'top-right');
    
    map.current.on('moveend', () => {
      localStorage.setItem("mapbox.lastCentre", JSON.stringify(map.current.getCenter()));
      localStorage.setItem("mapbox.lastZoom", JSON.stringify(map.current.getZoom()));
    });
    
  });

  

  function fireDevice(deviceId) {
    // API call to fire the device
    const headers = {
      'Content-Type': 'application/json',
      'X-API-KEY': '7EAFDEADBEEF'
    };
  
    fetch('/api/v1/fireSingle/' + deviceId + "/", { headers })
      .then(response => response.json())
      .then(responseJSON => {
        if (responseJSON.success === false) {
          toast.warn("No Response from: " + deviceId);
        } else {
          toast.success("Device fired successfully");
        }
        //setShowModal(false); // Close the modal after firing
      })
      .catch(error => {
        toast.error("Error firing device: " + error.message);
        console.error('Error firing device:', error);
      });
  }
  


  return (
    <div>
            <div className={styles.toolbar}>
              <Form.Check
                type="switch"
                id="toggle-oos-markers"
                label="Show ‘Out of Service’ devices"
                checked={showOutOfService}
                onChange={(e) => setShowOutOfService(e.target.checked)}
              />
            </div>


            <div ref={mapContainer} className={styles.mapcontainer} />
            
                        
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Device Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Cannon Number: {selectedDevice?.displayname?.displayName || "—"}</p>
                    <p>Board ID: {selectedDevice?.deviceID || "—"}</p>
                    <p>Firmware Version: {selectedDevice?.firmwareV || "—"}</p>
                    <p>Last Heard: {selectedDevice?.recordDate ? moment(selectedDevice.recordDate).format("DD-MMM-YY, hh:mm a") : "—"}</p>
                    <p>Battery Voltage: {selectedDevice?.batteryV != null ? `${selectedDevice.batteryV}V` : "—"}</p>
                    <p>Life Counter: {selectedDevice?.lifeCounter ?? "—"}</p>
                    <p>Misfire Counter: {selectedDevice?.misfires ?? "—"}</p>
                    <p>
                      Tank Counter: {selectedDevice?.tankCounter} <br />
                      Threshold: {
                        (() => {
                          const type = selectedDevice?.deviceType || "";
                          const match = Object.keys(tankThresholds.current).find(key => type.toLowerCase().includes(key.toLowerCase()));
                          return tankThresholds.current[match] || 15000;
                        })()
                      }
                    </p>
                    <p>
                      Status: {
                        getDeviceStatusReason(selectedDevice, tankThresholds.current)
                      }
                    </p>


                    <Form.Check
                      type="switch"
                      id="map-toggle-service"
                      label={selectedDevice?.outOfService ? "Out of Service" : "In Service"}
                      checked={!!selectedDevice?.outOfService}
                      onChange={() => toggleOutOfService(selectedDevice)}
                    />
                    
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={() => fireDevice(selectedDevice?.deviceID)}>
                        Fire
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}